import {
  createReduxMiddleware,
  defaultOptions,
} from '@karmaniverous/serify-deserify';
import { configureStore } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import { rootReducer } from './rootReducer';
import { setAppStore } from './storeRef';

// Serify is used to serialize and deserialize un-serializable values automatically
// This is necessary for slices such as Crate which contain Date properties which are inherintely unserializable
const serifyMiddleware = createReduxMiddleware(defaultOptions);

const sentryReduxEnhancer = Sentry.createReduxEnhancer({});

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(serifyMiddleware),
  enhancers: (defaultEnhancers) => [...defaultEnhancers, sentryReduxEnhancer],
});

setAppStore(store);

export type { AppDispatch, AppThunk, RootState } from './types';
export default store;
